import { render, staticRenderFns } from "./ReportesView.vue?vue&type=template&id=2c0c35f4&scoped=true&"
import script from "./ReportesView.vue?vue&type=script&lang=js&"
export * from "./ReportesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0c35f4",
  null
  
)

export default component.exports